import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import LoginForm from '../components/AccountPanel/LoginForm/LoginForm';
import RegisterForm from '../components/AccountPanel/RegisterForm/RegisterForm';
import ForgotPasswordForm from '../components/AccountPanel/ForgotPasswordForm/ForgotPasswordForm';
import ResetPasswordForm from '../components/AccountPanel/ResetPasswordForm/ResetPasswordForm';
import { TmCustomerCardPage } from './TmCustomerCardPage';
import { Login2FA } from '../components/AccountPanel/LoginForm/LoginForm2FA';
import OAuthCallback from '../components/AccountPanel/OAuthCallback/OAuthCallback';
import ErrorBoundary from '../components/layout/ErrorBoundary/ErrorBoundary';
import VerifyEmailPage from './VerifyEmailPage';

export default function WelcomePage() {
  return (
    <Router>
      <ErrorBoundary>
        <Switch>
          <Route path="/login-2fa">
            <Helmet>
              <title>FairFare Login</title>
            </Helmet>
            <Login2FA />
          </Route>
          <Route path="/oauth/callback">
            <Helmet>
              <title>Authentication</title>
            </Helmet>
            <OAuthCallback />
          </Route>
          <Route path="/verify-email">
            <Helmet>
              <title>FairFare Verify Email</title>
            </Helmet>
            <VerifyEmailPage />
          </Route>
          <Route path="/login">
            <Helmet>
              <title>FairFare Login</title>
            </Helmet>
            <LoginForm />
          </Route>
          <Route path="/card">
            <Helmet>
              <title>FairFare Card</title>
            </Helmet>
            <TmCustomerCardPage />
          </Route>
          <Route path="/register">
            <Helmet>
              <title>FairFare Register</title>
            </Helmet>
            <RegisterForm />
          </Route>
          <Route path="/forgot-password">
            <Helmet>
              <title>FairFare forgot password</title>
            </Helmet>
            <ForgotPasswordForm />
          </Route>
          <Route path="/reset-password">
            <Helmet>
              <title>FairFare Reset Password</title>
            </Helmet>
            <ResetPasswordForm />
          </Route>
          <Route path="/">
            <Helmet>
              <title>FairFare Login</title>
            </Helmet>
            <LoginForm />
          </Route>
        </Switch>
      </ErrorBoundary>
    </Router>
  );
}
